import { faPercentage } from '@fortawesome/pro-solid-svg-icons';

import { MarketCredit } from '@sorare/core/src/atoms/icons/MarketCredit';
import { FilterWidget, TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { ToggleFilter } from 'searchCards/ToggleFilter';

const FILTER = TOGGLE_FILTERS.creditEligibleFilter;

export const widget = ({
  startsOpen = true,
}: {
  startsOpen?: boolean;
} = {}): FilterWidget => ({
  key: FILTER.attribute,
  type: 'toggle',
  attribute: FILTER.attribute,
  Component: () => (
    <ToggleFilter
      nodeIcon={<MarketCredit width={16} height={16} />}
      icon={faPercentage}
      filter={FILTER}
      on={['PrimaryOffer', 'EnglishAuction']}
    />
  ),
  accordionOptions: { startsOpen },
});
